<template>
  <div class="w-full bg-white border-round">
    <!-- <div class="p-4 bg-f9 border-round">
      <div
        class="flex w-full items-start bordb pb-5"
        v-for="(item, index) in this.totalextensions"
        :key="index"
      >
        <div class="w-9/12 flex gap-3 items-center">
          <img
            :src="showImage(item.image)"
            class="object-cover w-24 h-24 border-round"
            alt="banh"
          />

          <div>
            <small class="fsize10 text-6b6b6b opacity-80 font-medium"
              >Brained Studio</small
            >
            <h2 class="text-dark fsize14 font-semibold">{{ item.name }}</h2>
            <p
              class="font-semibold fsize10 text-dark font-medium flex items-center"
            ></p>
          </div>
        </div>
        <div class="w-3/12 flex justify-end">
          <p class="text-primary fsize16 font-semibold mb-0">
            {{ currencySymbol }}{{ item.price }}
          </p>
        </div>
      </div>
      <div class="flex justify-between items-center mt-3">
        <small class="fsize12 text-6b6b6b opacity-80 font-medium"
          >Any Details you'd like to mention?</small
        >
        <img src="@/assets/images/plus.png" alt="plusicon" class="w-6" />
      </div>
    </div> -->
    <div class="mt-10" v-if="currencySymbol !== 'S$'">
      <p class="font-semibold third-fonts">Offers & Benefits</p>
      <div class="grid grid-cols-1 gap-4 mt-3 bg-f9 px-6 py-2 border-round">
        <el-collapse>
          <el-collapse-item name="1" class="bgcollsp">
            <template slot="title">
              <p class="font-semibold text-6b6b6b bg-f9 mb-0">
                Apply Coupon Code
              </p>
            </template>
            <div
              class="p-2 bg-f9 flex justify-between items-end"
              v-for="(i, index) in this.allCoupons"
              :key="index"
            >
              <!-- Consistent with real life: in line with the process and logic of
              real life, and comply with languages and habits that the users are
              used to; -->
              {{ i.couponCode }}
              <span
                variant="primary"
                class="text-primary font-semibold sm-fsize6 underline cursor-pointer"
                v-if="i.usage == 'Used'"
                >Used
              </span>
              <span
                @click="selectedCoupon(i)"
                variant="primary"
                class="text-primary font-semibold sm-fsize6 underline cursor-pointer"
                v-else-if="couponSelected.couponCode != i.couponCode"
                >Apply
              </span>
              <span
                @click="removeCoupon(i)"
                variant="primary"
                class="text-primary font-semibold sm-fsize6 underline"
                v-else-if="couponSelected.couponCode === i.couponCode"
                >Remove
              </span>
            </div>
          </el-collapse-item>
        </el-collapse>
      </div>
    </div>

    <div class="mt-10">
      <p class="font-semibold third-fonts">Extension</p>
      <div class="grid grid-cols-1 gap-4 mt-3 bg-f9 px-6 py-2 border-round">
        <el-collapse class="addons">
          <el-collapse-item name="1" class="bgcollsp">
            <template slot="title">
              <p class="font-semibold text-6b6b6b bg-f9 mb-0">
                Free Extension ({{ this.selectedPlan[0].extension.remaining }})
              </p>
            </template>
          </el-collapse-item>
        </el-collapse>
      </div>
    </div>
    <div class="mt-8" v-if="this.selectedPlan[0].extension.remaining < 1">
      <p class="font-semibold third-fonts">Bill Summary</p>

      <div class="grid grid-cols-1 gap-4 mt-3 bg-f9 py-4 px-6 border-round">
        <el-collapse v-model="activeName" accordion>
          <el-collapse-item name="1" class="bgcollsp">
            <template slot="title">
              <p class="font-semibold text-6b6b6b bg-f9 mb-0">
                Items Total (<span>{{ this.totalextensions.length }}</span
                >)
              </p>
            </template>
            <div
              class="flex justify-between items-end"
              v-for="(item, index) in this.totalextensions"
              :key="index"
            >
              <div>
                <h2 class="text-dark fsize14 font-semibold">
                  {{ item.name }}
                </h2>
              </div>
              <div class="" v-if="currencySymbol !== 'S$'">
                <p class="col-4f fsize14 opacity-80 font-semibold">
                  {{ currencySymbol }}{{ item.price }}
                </p>
              </div>
            </div>
          </el-collapse-item>
        </el-collapse>

        <div
          class="flex justify-between items-end"
          v-if="currencySymbol !== 'S$'"
        >
          <div>
            <small class="fsize12 text-6b6b6b opacity-80 font-medium"
              >Taxes & Charges</small
            >
            <h2 class="text-dark fsize14 font-semibold">
              {{ gstNumberValue }}% GST
            </h2>
          </div>
          <div class="">
            <p class="col-4f fsize14 font-semibold">
              +{{ currencySymbol }}{{ calculation.gst }}
            </p>
          </div>
        </div>
        <div
          class="flex justify-between items-end bordb pb-2"
          v-if="currencySymbol !== 'S$'"
        >
          <div>
            <small class="fsize12 text-6b6b6b opacity-80 font-medium"
              >Promo Code</small
            >
            <h2 class="text-dark fsize14 font-semibold">
              {{ this.couponSelected.couponCode }}
            </h2>
          </div>
          <div class="">
            <p class="col-4f fsize14 font-semibold opacity-80">
              -{{ currencySymbol }}{{ this.discountRs }}
            </p>
          </div>
        </div>
        <div
          class="flex justify-between items-center"
          v-if="currencySymbol !== 'S$'"
        >
          <div class="poppy">
            <h2
              class="text-dark fsize14 my-0 font-semibold flex gap-2 items-center"
            >
              Total Amount
            </h2>
            <feather-icon icon="InfoIcon" svgClasses="w-4 h4" />
            <div class="bg-white shadow pt-2 absolute bottom-0 shadow pophover">
              <h5 class="fsize14 p-2 font-semibold text-black">
                Amount for 24 remaning days in this month's bill cycle:
              </h5>
              <div class="flex gap-2 p-2 items-center my-2">
                <div class="">
                  <p class="bordb fsize14 text-dark font-semibold">
                    {{ currencySymbol }}24000
                  </p>
                </div>
                <p class="bordb fsize14 text-dark font-semibold">
                  * {{ this.totalextensions.length }}
                </p>
                <div class="flex items-center gap-2">
                  <p class="text-dark font-semibold">
                    +{{ currencySymbol }}{{ calculation.gst }}
                  </p>
                </div>
                <div class="flex items-center gap-2">
                  <p class="text-dark font-semibold">
                    -{{ currencySymbol }}{{ this.discountRs }}
                  </p>
                </div>
                <div class="flex items-center gap-2">
                  <p class="text-success font-semibold">=</p>
                  <p class="text-success font-semibold">
                    {{ currencySymbol
                    }}{{
                      this.isCouponSelected
                        ? this.afterDiscountAmt
                        : this.calculation.total
                    }}
                  </p>
                </div>
              </div>
              <div class="bg-f9 p-2">
                <div class="flex items-start gap-2">
                  <h6
                    class="fsize12 font-medium text-dark w-3/12 flex justify-end"
                  >
                    {{ currencySymbol }}24000 :
                  </h6>
                  <p class="fsize12 font-normal text-gray w-9/12">
                    Amount per Extension
                  </p>
                </div>
                <div class="flex items-start gap-2">
                  <h6
                    class="fsize12 font-medium text-dark w-3/12 flex justify-end"
                  >
                    {{ currencySymbol }}{{ this.discountRs }} :
                  </h6>
                  <p class="fsize12 font-normal text-gray w-9/12">
                    Coupon code discount
                  </p>
                </div>
                <div class="flex items-start gap-2">
                  <h6
                    class="fsize12 font-medium text-dark w-3/12 flex justify-end"
                  >
                    {{ this.totalextensions.length }} :
                  </h6>
                  <p class="fsize12 font-normal text-gray w-9/12">
                    No. of Extension in cart
                  </p>
                </div>
                <div class="flex items-start gap-2 mt-1">
                  <h6
                    class="fsize12 font-medium text-dark w-3/12 flex justify-end"
                  >
                    {{ currencySymbol }}{{ calculation.gst }} :
                  </h6>
                  <p class="fsize12 font-normal text-gray w-9/12">Tax</p>
                </div>
              </div>
            </div>
          </div>
          <div class="">
            <p class="col-4f fsize14 font-semibold">
              {{ currencySymbol
              }}{{
                this.isCouponSelected
                  ? this.afterDiscountAmt
                  : this.calculation.total
              }}
            </p>
          </div>
        </div>
      </div>
    </div>
    <div
      class="flex justify-between w-full mt-8 px-2 items-center"
      v-if="this.selectedPlan[0].extension.remaining < 1"
    >
      <div v-if="currencySymbol !== 'S$'">
        <small class="col-4f fsize14 font-semibold fsize12">
          {{ currencySymbol
          }}{{
            this.isCouponSelected ? this.afterDiscountAmt : calculation.total
          }}
        </small>
        <h2 class="text-primary fsize16 font-semibold">Bill Summary</h2>
      </div>
      <div class="">
        <vs-button
          @click="
            () => {
              if (currencySymbol === 'S$') {
                SGMailTriggregd();
              } else {
                orderConfirm();
              }
            }
          "
          variant="primary"
          class="rounded-full bg-primary border-0 text-white font-semibold lg:py-4 md:py-3 py-2 px-8 sm-fsize14"
        >
          {{ currencySymbol === "S$" ? "Get Quote" : " Proceed to pay" }}
        </vs-button>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
export default {
  props: {
    currencySymbol: {
      type: String,
    },
    gstNumberValue: {
      type: Number,
    },
  },
  watch: {
    totalextensions(val2) {
      if (val2.length) {
        if (this.currencySymbol === "S$") {
          this.activeName = "1";
        } else {
          this.activeName = "";
        }
      }
    },
  },
  data() {
    return {
      activeName: "",
      isCouponSelected: false,
      couponSelected: {},
      withoutDiscount: {},
      afterDiscountAmt: 0,
      discountRs: 0,
      allCoupons: "",
    };
  },
  methods: {
    async SGMailTriggregd() {
      console.log("ENtered");
      let payload = {
        names: "Extensions",
        projectName: this.selectedProject.projectName,
        collectionData: this.totalextensions.name,
      };
      let { data } = this.$store.dispatch("Extensions/mailTriggred", payload);
      if (data) {
        this.$swal({
          text: "Successfully Mail Send",
          icon: "success",

          confirmButtonColor: "#830c81",
          // cancelButtonColor: "#d33",
          confirmButtonText: "Okay",
        });
      }
    },
    async orderConfirm() {
      let Ids = [];
      this.totalextensions.forEach((element) => {
        Ids.push(element._id);
      });
      try {
        const order_data = await this.$store.dispatch(
          "Extensions/createExtensionOrder",
          {
            userId: this.login._id,
            projectId: this.selectedProject._id,
            projectName: this.selectedProject.projectName,
            amount: this.isCouponSelected
              ? this.afterDiscountAmt
              : this.calculation.total,
            extensionId: Ids,
            currency: "INR",
          }
        );

        const options = {
          key: process.env.VUE_APP_RAZORPAY_KEY,
          currency: "INR",
          order_id: this.extensionsorders.orderId,
          prefill: {
            name: this.login.name,
            email: this.login.email,
            contact: this.login.mobile,
          },
          handler: async (response) => {
            await this.successResponse();
          },
        };
        const rzp = await new Razorpay(options);
        rzp.open();
      } catch (error) {}
    },
    async successResponse() {
      for (let i = 0; i < this.totalextensions.length; i++) {
        const req_data = await this.$store.dispatch(
          "Extensions/addExtensionRequest",
          {
            projectName: this.selectedProject.projectName,
            extensionId: this.totalextensions[i]._id,
            extensionName: this.totalextensions[i].name,
            projectId: this.selectedProject._id,
            orderId: this.extensionsorders._id,
            paymentStatus: "Paid",
          }
        );
      }
      await this.$router.push({ name: "extentions-OrderConfirm" });
      if (this.couponSelected) {
        const couponpayload = {
          projectId: this.selectedProject._id,
          couponUsed: this.couponSelected,
        };
        await this.$store.dispatch("user/updateProject", couponpayload);
        await this.$store.dispatch("user/getProject", {
          projectId: this.selectedProject._id,
        });
        await this.filterUsedCoupon();
      }
      this.removeAll();
    },
    showImage(value) {
      let default_image = require("@/assets/images/card1.png");
      let image_base_url = this.$imageURL;

      return value ? `${image_base_url}/${value}` : default_image;
    },
    async selectedCoupon(value) {
      this.isCouponSelected = true;
      this.isApplied = true;
      this.discountRs = 0;
      this.afterDiscountAmt = 0;
      this.couponSelected = value;
      // let { data } = await this.$store.dispatch("studio/submitCoupon", {
      //   couponCode: this.couponSelected.couponCode,
      //   totalPrice: this.calculation.beforeTotal,
      // });
      // this.withoutDiscount = data;
      // this.offPrice = data.discountPrice;
      // this.discountedPrice = data.finalPrice;
    },
    removeCoupon() {
      this.isCouponSelected = false;
      this.couponSelected = {};
      this.discountRs = 0;
      this.afterDiscountAmt = 0;
      // let price = this.withoutDiscount.beforePrice;
      // let gst = price * 0.18;
      // price = price + gst;
      // this.withGst = price;
    },
    removeAll() {
      this.isCouponSelected = false;
      this.couponSelected = {};
      this.discountRs = 0;
      this.afterDiscountAmt = 0;
      this.calculation.total = 0;
      this.totalextensions = [];
    },
    async getCoupons() {
      let coupon_data = await this.$store.dispatch("studio/getCoupons", {
        isExpired: true,
      });
    },
    filterUsedCoupon() {
      this.allCoupons = this.getcoupons;
      for (let i = 0; i < this.selectedProject.couponUsed.length; i++) {
        for (let j = 0; j < this.allCoupons.length; j++) {
          if (
            this.selectedProject.couponUsed[i]._id == this.allCoupons[j]._id
          ) {
            this.allCoupons[j].usage = "Used";
          }
        }
      }
      console.log(this.allCoupons, "all coupons");
      console.log(this.selectedProject.couponUsed, "dbcoupon");
    },
  },
  computed: {
    ...mapState("Extensions", [
      "extensions",
      "totalextensions",
      "extensionsorders",
    ]),
    ...mapState("admin", ["login", "selectedPlan"]),
    ...mapState("user", ["selectedProject"]),
    ...mapState("studio", ["itemstotal", "createorder", "getcoupons"]),

    calculation() {
      let total = 0;
      let amt = [];
      for (var i = 0; i < this.totalextensions.length; i++) {
        if (this.totalextensions[i].price === "Free") {
          amt.push(0);
        } else {
          amt.push(parseInt(this.totalextensions[i].price));
        }
      }
      for (i = 0; i < amt.length; i++) {
        total = total + amt[i];
      }
      if (
        this.totalextensions.length > this.selectedPlan[0].extension.remaining
      ) {
        var ExtensionToPay =
          this.totalextensions.length -
          this.selectedPlan[0].extension.remaining;
      } else if (
        this.totalextensions.length <= this.selectedPlan[0].extension.remaining
      ) {
      }
      let amount = ExtensionToPay > 0 ? ExtensionToPay : 0;
      let gstVal = this.gstNumberValue / 100;
      let gst = amount * 24000 * gstVal;

      if (
        this.totalextensions.length > this.selectedPlan[0].extension.remaining
      ) {
        this.countedExtension = 0;
        if (
          this.selectedPlan[0].extension.remaining ==
          this.totalextensions.length - 1
        ) {
        }
      } else {
        this.countedExtension =
          this.selectedPlan[0].extension.remaining -
          this.totalextensions.length;
      }
      total = amount * 24000 + gst;
      // coupon mgmt
      if (this.isCouponSelected) {
        new Promise(async (resolve, reject) => {
          try {
            let { data } = await this.$store.dispatch("studio/submitCoupon", {
              couponCode: this.couponSelected.couponCode,
              totalPrice: total + gst,
            });

            if (data) {
              total = data.finalPrice;
              this.discountRs = data.discountPrice;
              this.afterDiscountAmt = data.finalPrice;
            }
            // resolve(data);
          } catch (error) {
            reject(error);
          }
        });
      }

      return { gst: gst, total: total };
    },
  },
  async mounted() {
    await this.getCoupons();
    await this.filterUsedCoupon();
  },
};
</script>
